import _ from "@/boot/lodash";
import type {
  IBillingCycle,
  IBillingTermsOption
} from "@upmind-automation/types";

export default {
  data: () => ({
    billingCyclesLoaded: false
  }),
  computed: {
    getBillingCycleName() {
      return this.$store.getters["constants/getBillingCycleName"];
    },
    billingCycles(): IBillingCycle[] {
      return this.$store.state.constants.billingCycles;
    },
    billingTermsOptions(): IBillingTermsOption[] {
      return _.map(this.billingCycles, billingTerm => ({
        value: billingTerm.months,
        label: billingTerm.name
      }));
    }
  },
  methods: {
    async created() {
      await this.getBillingCycles();
      this.billingCyclesLoaded = true;
    },

    getBillingCycles() {
      return this.$store.dispatch("constants/getBillingCycles");
    }
  }
};
